function Modal(el) {
	var trigger,
		triggerSelector = el.getAttribute('data-modal-trigger');

	el.addEventListener('click', function(e) {
		if (e.target === el) {
			el.classList.remove('js-active');
		}
	});

	if (! triggerSelector) {
		return;
	}

	trigger = document.querySelector(triggerSelector);
	trigger.addEventListener('click', function() {
		el.classList.add('js-active');
	});
}

module.exports = Modal;
